<template>
  <div>
    <div class="row m-0">
      <div class="col-12 col-md-7">
        <div class="row">
          <div class="col-12 col-md-8 bg-gradient-two p-3">
            <h2 class="font-weight-bold text-left product-title">
              {{ product.name }}
            </h2>
            <h6 class="font-weight-normal text-left mt--half text-sm mt-1 mb-0">
              <div>{{ product.company.name }}{{ product.brand ? ` | ${product.brand.name} (brand)` : "" }}</div>
            </h6>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-5 m-auto">
        <ProductDisplayPrice
          :hide-prices="hidePrices"
          :product="product"
          :selected-batch="selectedBatch"
          :selected-product="selectedProduct"
          @contact-button-clicked="$emit('contactButtonClicked')"
        />
      </div>
    </div>
    <div class="row m-0">
      <div class="col-12 col-md-7 mt-2">
        <div class="mb-4 mt-3">
          <h5>Description</h5>
          <h6 class="font-weight-normal text-left mt--half text-sm mt-1 mb-2">
            <span v-if="product.category && product.category.name"> {{ product.category.name }}</span>
            <span v-if="product.product_type && product.product_type.name"> | {{ product.product_type.name }} </span>
            <span v-if="product.cultivar && product.cultivar.name"> | {{ product.cultivar.name }} </span>
            <span v-if="product.cultivar_type && product.cultivar_type.name">
              <div v-if="product.cultivar_type && product.cultivar_type.name" class="align-items-center" style="display: inline; z-index: 2">
                |
                <div
                  v-if="product.cultivar_type"
                  style="border-radius: 0.35rem; padding-top: 2px; padding-bottom: 2px"
                  :class="cultivarType(product.cultivar_type.name)"
                >
                  {{ product.cultivar_type.name }}
                </div>
              </div>
            </span>
          </h6>
          <div class="product-description-container">
            <span v-if="product.description" v-html-safe="product.description" style="white-space: pre-line" />
          </div>
        </div>
        <div class="mb-3">
          <!-- <h5>
            Details
          </h5> -->
          <div v-if="!hideQuantities">
            <p class="mb-0">
              {{ getPackageCaseOptions(product) }}
            </p>
            <p v-if="getUnitSize(product)" class="mb-0">Weight: {{ getUnitSize(product) }}</p>
            <p v-if="product.packaged_unit_size" class="mb-0">Package Size: {{ product.packaged_unit_size }}</p>
            <p v-if="product.gram_per_preroll" class="mb-0">Weight: {{ product.gram_per_preroll }} Grams</p>

            <p v-if="pdpSizesAvailable(product) && pdpSizesAvailable(product).length" class="mb-0">
              Sizes Available: {{ pdpSizesAvailable(product) }}
            </p>
          </div>

          <ProductTagCloud class="mt-2" :product="product" />
        </div>
        <div v-if="product.ingredients" class="mb-3">
          <h5 class="mb-1">Ingredients</h5>
          <p style="white-space: pre-line">
            {{ product.ingredients }}
          </p>
        </div>
      </div>
      <div class="col-12 col-md-5 pr-0 pb-3">
        <ProductDisplayPageImages :product="product" />
      </div>
    </div>
  </div>
</template>
<script>
import ProductTagCloud from "./ProductTagCloud.vue";
import ProductDisplayPageImages from "./ProductDisplayPageImages.vue";
import ProductDisplayPrice from "./ProductDisplayPrice.vue";
import { cultivarType, pdpSizesAvailable, getPackageCaseOptions, getUnitSize } from "@/services/storefront/storefront";

export default {
  components: {
    ProductTagCloud,
    ProductDisplayPageImages,
    ProductDisplayPrice,
  },
  props: {
    product: { type: Object, default: null },
    hidePrices: { type: Boolean, required: true },
    hideQuantities: { type: Boolean, required: true },
    selectedBatch: { type: Object, required: true },
    selectedProduct: { type: Object, default: null },
  },
  emits: ["contactButtonClicked"],
  data() {
    return {};
  },
  computed: {},
  mounted() {},
  methods: {
    cultivarType,
    pdpSizesAvailable,
    getPackageCaseOptions,
    getUnitSize,
    showProductMethods(product) {
      let show = false;
      if (
        (product.crude_extract_sub_type && product.crude_extract_sub_type.name) ||
        (product.distillate_extract_sub_type && product.distillate_extract_sub_type.name) ||
        (product.state_of_material && product.state_of_material.name) ||
        (product.grow_environment && product.grow_environment.name) ||
        (product.grow_medium && product.grow_medium.name) ||
        (product.drying_method && product.drying_method.name) ||
        (product.storage_type && product.storage_type.name) ||
        (product.container_type && product.container_type.name) ||
        (product.trim_method && product.trim_method.name) ||
        (product.flowering_period && product.flowering_period.name) ||
        (product.feminized_type && product.feminized_type.name) ||
        product.lineage ||
        product.feminized ||
        product.germination_rate ||
        product.herm_male_rate ||
        product.yields_per_acre_outdoor ||
        product.per_sq_ft_indoor ||
        product.curing_method ||
        (product.extraction_method && product.extraction_method.name) ||
        (product.flavor && product.flavor.name) ||
        (product.infusion_method && product.infusion_method.name) ||
        product.for_pets ||
        (product.environmental_issues && product.environmental_issues.length > 0)
      ) {
        show = true;
      }
      return show;
    },
  },
};
</script>

<style scoped>
.product-description-container {
  width: 100%;
  overflow-wrap: break-word;
  word-wrap: break-word;
  word-break: break-word;
  hyphens: auto;
  max-width: 100%;
}

.product-description-container :deep(*) {
  max-width: 100%;
  overflow-wrap: break-word;
  word-wrap: break-word;
  word-break: break-word;
}
</style>
